document.addEventListener('DOMContentLoaded', (event) => {
  const insertQuestionMarkAndPopup = () => {
    let wrapper = document.querySelector('.subify-max-discount-badge-wrapper');

    if (wrapper) {
      // Create the question mark div
      let questionMark = document.createElement('div');
      questionMark.textContent = '?';
      questionMark.style.display = 'inline-block';
      questionMark.style.marginLeft = '8px';
      questionMark.style.cursor = 'pointer';
      questionMark.id = 'questionMark';

      wrapper.parentNode.insertBefore(questionMark, wrapper.nextSibling);

      // Create the popup
      let popup = document.createElement('div');
      popup.id = 'popup';
      popup.innerHTML =
        '20% savings + special deals<br>Skip or cancel delivery any time<br>Be the first to know about special promotions';
      popup.style.display = 'none';
      popup.style.position = 'absolute';
      popup.style.top = 'calc(60% + 10px)';
      popup.style.left = '50%';
      popup.style.transform = 'translateX(-50%)';
      popup.style.backgroundColor = 'white';
      popup.style.padding = '20px';
      popup.style.border = '1px solid black';
      popup.style.boxShadow = '2px 2px 10px rgba(0, 0, 0, 0.2)';
      popup.style.borderRadius = '5px';
      popup.style.zIndex = '1000';
      popup.style.maxWidth = '500px';
      popup.style.textAlign = 'left';

      // Create overlay for closing the popup
      let overlay = document.createElement('div');
      overlay.id = 'overlay';
      overlay.style.display = 'none';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.background = 'rgba(0, 0, 0, 0.3)';
      overlay.style.zIndex = '999';

      // Append popup and overlay to body
      document.body.appendChild(popup);
      document.body.appendChild(overlay);

      // Show popup when clicking the question mark
      questionMark.addEventListener('click', () => {
        popup.style.display = 'block';
        overlay.style.display = 'block';
      });

      // Hide popup when clicking outside
      overlay.addEventListener('click', () => {
        popup.style.display = 'none';
        overlay.style.display = 'none';
      });
    } else {
      console.error('Wrapper element not found.');
    }
  };

  setTimeout(insertQuestionMarkAndPopup, 1100);
});
